module.exports = __webpack_public_path__ + "img/icon_102.d726169d.png";